export default "__VITE_ASSET__0a1c5f87__"